import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.css']
})
export class PageHeaderComponent {
  @Input() Icon: string = ''
  @Input() Heading: string = 'Insert Page Heading'
  @Input() Description: string = ''
  @Input() details: string = ''
}
